import React, { useEffect, useState } from "react";
import LayoutOptions from "components/LayoutOptions/LayoutOptions";
import { STab, STabList, STabPanel, STabs } from "./layoutSettingsTabsStyles";
import { useAppSelector } from "hooks/redux";
import { useDispatch } from "react-redux";
import { setGridPage } from "store/reducers/TabsSlice";

const LayoutSettingsTabs = () => {
    const currentPage = useAppSelector((state) => state.tabs.currentGridPage);
    const dispatch = useDispatch();

    return (
        <>
            <STabs
                selectedTabClassName="is-selected"
                selectedTabPanelClassName="is-selected"
                onSelect={(index: number) => {
                    dispatch(setGridPage(index));
                }}
                selectedIndex={currentPage}
            >
                <STabList>
                    <STab>1</STab>
                    <STab>2</STab>
                    <STab>3</STab>
                    <STab>4</STab>
                </STabList>
                <STabPanel>
                    <LayoutOptions tabNumber={1} />
                </STabPanel>
                <STabPanel>
                    <LayoutOptions tabNumber={2} />
                </STabPanel>
                <STabPanel>
                    <LayoutOptions tabNumber={3} />
                </STabPanel>
                <STabPanel>
                    <LayoutOptions tabNumber={4} />
                </STabPanel>
            </STabs>
        </>
    );
};

export default LayoutSettingsTabs;
